import React from 'react';
import { cn } from '../../utils/cn';
import { isWhiteLabel } from '../../config/tenantConfig';

interface CheckboxProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  id?: string;
  label?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  disabled,
  id,
  label,
  description,
  className,
}) => {
  const wl = isWhiteLabel();
  const accent = wl ? 'text-zebu-600 focus:ring-zebu-500' : 'text-blue-600 focus:ring-blue-500';

  const input = (
    <input
      id={id}
      type="checkbox"
      checked={checked}
      disabled={disabled}
      onChange={(e) => onChange(e.target.checked)}
      className={cn(
        'h-4 w-4 rounded border-gray-300 dark:border-gray-600 focus:ring-2 disabled:opacity-50',
        accent,
      )}
    />
  );

  if (!label && !description) {
    return <span className={className}>{input}</span>;
  }

  return (
    <label
      htmlFor={id}
      className={cn(
        'inline-flex items-start gap-2 select-none',
        disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
        className,
      )}
    >
      {input}
      {(label || description) && (
        <span className="inline-flex flex-col">
          {label && (
            <span className="text-sm text-gray-700 dark:text-gray-200 inline-flex items-center gap-1">
              {label}
            </span>
          )}
          {description && (
            <span className="text-xs text-gray-500 dark:text-gray-400">{description}</span>
          )}
        </span>
      )}
    </label>
  );
};

export default Checkbox;
